import React from "react";
import BarraSupDent from "../../commons/BarraSupDent";
import Title from "../Login/Components/title/title";
import AddButton from "../../commons/AddButton";
import { Link } from "react-router-dom";
import NavbarDownConsumer from "../../commons/NavbarDownConsumer";

class MoreDents extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  render() {
    return (
      <div>
        <BarraSupDent />
        <Title text1="Do you have any other dents?" />
        <div className="mt-5 pt-5">
          <Link to="/Location">
            <AddButton text="Continue to next step" />
          </Link>
          <Link to="/Photos">
            <AddButton text="Add another dent" />
          </Link>
        </div>
        <NavbarDownConsumer />
      </div>
    );
  }
}

export default MoreDents;
